import { Injectable, inject } from '@angular/core';
import { BaseInitAppService } from '@shared/core';
import { Observable, catchError, map, of, switchMap, tap } from 'rxjs';
import { AppInitManagerService } from './app-init-manager.service';

@Injectable({
    providedIn: 'root',
})
export class InitAppService extends BaseInitAppService {
    private readonly appInitManagerService = inject(AppInitManagerService);
    public override appInitError$ = this.appInitManagerService.appInitError$;
    public override appModules$ = this.appInitManagerService.appModules$;
    public override appPwaSettings$ = this.appInitManagerService.appPwaSettings$;
    public override appType$ = this.appInitManagerService.appType$;

    public initApp(): Observable<void> {
        return of(null).pipe(
            switchMap(() => this.appInitManagerService.loadAppModules()),
            switchMap(() => this.appInitManagerService.getRealmAndClient()),
            catchError(() => {
                this.appInitManagerService.setAppInitError();
                return of(null);
            }),
            tap(() => {
                this.isInitializedSubject.next(true);
            }),
            map(() => void 0),
        );
    }

    public override navigateHome(): Observable<void> {
        return this.appRoutingManagerService.toHome();
    }

    public override navigateToAppInitializerError(): Observable<void> {
        return this.appRoutingManagerService.toError();
    }
}
